import axios from '@/plugins/axios';

export async function index(params = {}, filters = {}){
    return await axios.post('admin/workspaces', {filters}, {params});
}

export async function show(workspaceId){
    return await axios.get(`admin/workspaces/${workspaceId}`);
}

export async function users(workspaceId, params = {}){
    return await axios.get(`admin/workspaces/${workspaceId}/users`, {params});
}

export async function organizations(workspaceId, params = {}){
    return await axios.get(`admin/workspaces/${workspaceId}/organizations`, {params});
}